export default __webpack_public_path__ + "static/media/confirm.3aef7530.png";